import request from '@/utils/request'

// 查询
export function fetchList (data) {
  return request.post('/system/config/page', data)
}

// 根据Key查询
export function fetchByKey (data) {
  return request.get(`/system/config/key/${data}`)
}

// 新建
export function create (data) {
  return request.post('/system/config/create', data, {
    trim: true
  })
}

// 修改
export function updateById (data) {
  return request.post('/system/config/updateById', data, {
    trim: true
  })
}

// 删除
export function deleteById (id) {
  return request.get(`/system/config/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/system/config/delete/batch', {
    params: {
      ids
    }
  })
}
